import { render } from "./CocktailsPagination.vue?vue&type=template&id=c23f9594&scoped=true"
import script from "./CocktailsPagination.vue?vue&type=script&lang=js"
export * from "./CocktailsPagination.vue?vue&type=script&lang=js"

import "./CocktailsPagination.vue?vue&type=style&index=0&id=c23f9594&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c23f9594"]])

export default __exports__